"use client";

import { Button } from "@relume_io/relume-ui";
import React, { useMemo } from "react";
import { ABOUT_HERO_IMAGES } from "../../constants/about-images";
import { motion } from "framer-motion";

export function Header50() {
  // Select a random image on component mount
  const randomImage = useMemo(() => {
    const randomIndex = Math.floor(Math.random() * ABOUT_HERO_IMAGES.length);
    return ABOUT_HERO_IMAGES[randomIndex];
  }, []); // Empty dependency array means this only runs once when component mounts

  return (
    <section id="relume" className="relative px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container">
        <div className="w-full max-w-lg">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="inline-flex items-center rounded-full bg-blue-400/10 px-4 py-1.5 text-sm font-medium text-blue-400 ring-1 ring-inset ring-blue-400/20"
          >
            Unify
          </motion.h2>
          <h1 className="mb-5 text-6xl font-bold text-text-alternative md:mb-6 md:text-9xl lg:text-10xl">
            Empowering Storytelling Together
          </h1>
          <p className="text-text-alternative md:text-md">
            At Omnigeist, we revolutionize storytelling by creating
            interconnected narratives across multiple mediums and platforms.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <a
              href="/product"
              className="rounded-md bg-primary px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
            >
              Discover
            </a>
            <a
              href="/contact?type=product"
              className="text-sm font-semibold leading-6 text-gray-300 hover:text-white"
            >
              Join Beta Waitlist <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </div>
      <div className="absolute inset-0 -z-10">
        <img
          src={randomImage}
          className="size-full object-cover"
          alt="Omnigeist hero image"
        />
        <div className="absolute inset-0 bg-black/50" />
      </div>
    </section>
  );
}
